var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.045,
    height: 86.501,
    viewBox: "0 0 66.045 86.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bag",
    transform: "translate(-751.001 -1177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M9512,35.038c0-17.585,13.651-33.365,30.274-34.937h.152a24.339,24.339,0,0,1,2.686-.1c19.463,0,35.073,19.275,32.691,38.943q-.081.59-.184,1.155c-2.864,15.718-18.8,17.75-32.508,17.75C9530.974,57.848,9512,55.465,9512,35.038Z",
    transform: "translate(-8761 1205.653)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M126.3,8.414l-5.068,15.374H96.191L91.122,8.414a2.443,2.443,0,0,1,.3-2.281A2.643,2.643,0,0,1,93.5,5.068h8.059a7.573,7.573,0,0,1,14.293,0h8.059a2.643,2.643,0,0,1,2.078,1.064,2.443,2.443,0,0,1,.3,2.281Zm0,0",
    transform: "translate(675.404 1177)",
    fill: "#0055af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M213.587,8.413l-5.068,15.374H196V0a7.629,7.629,0,0,1,7.147,5.068h8.059a2.643,2.643,0,0,1,2.078,1.064,2.443,2.443,0,0,1,.3,2.281Zm0,0",
    transform: "translate(588.113 1177)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M126.478,126.068a5.083,5.083,0,0,1-5.068,5.068H96.068a5.068,5.068,0,0,1,0-10.137H121.41A5.083,5.083,0,0,1,126.478,126.068Zm0,0",
    transform: "translate(675.374 1076.442)",
    fill: "#fdb913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M1.89-79.7v-2.937h2.32v-7.693H9.532l3.7,7.693h4.355v-7.693h4.522v7.693h2.52V-79.7h-2.52v1.752h2.52v2.937h-2.52V-66.4H17.142l-4.255-8.611H8.731V-66.4H4.209v-8.611H1.89v-2.937h2.32V-79.7Zm13.617,1.752h2.086V-79.7H14.655Zm-6.775,0h2.72L10.584-79.7H8.731Zm8.928,4.556h.05q-.067-.567-.1-1.619h-.667Q17.309-74.222,17.659-73.388ZM8.681-83.851H8.615q.033.534.067,1.218h.484Q8.965-83.133,8.681-83.851Z",
    transform: "translate(771.11 1314.811)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.bfc06c78f98e79f38e8b0585628e460d.svg";
export { ForwardRef as ReactComponent };